import Button from '@/components/Button.jsx';
import { FiInfo, FiChevronDown } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2.jsx';
import DashboardLines from '@/screens/home/components/DashboardLines.jsx';
import Pagination from '@/components/pagination/Pagination.jsx';
import { cleanClass } from '@shared/utils/cleanClass.js';
import React, { useState, useRef } from 'react';

const PageSection = React.forwardRef(({ variant = '', prefix, title, titleContent, tag, info, description, header, footer, children, className = '', style = {}, icon, lines = false, actions = [], onHeaderClick = () => {}, collapsible = false, collapseByDefault = false, hideIfEmpty = false, pagination }, ref) => {
  const [isCollapsed, setIsCollapsed] = useState(collapseByDefault);
  const hasNoValidChildren = !children || children?.length === 0 || children?.filter?.(Boolean)?.every?.((child) => child === null || child === undefined);
  const [isScrolled, setIsScrolled] = useState(false);
  const contentRef = useRef(null);

  const handleScroll = (e) => {
    setIsScrolled(e.target.scrollTop > 0);
  };

  const toggleCollapse = (e) => {
    if (collapsible) {
      e.stopPropagation();
      setIsCollapsed(!isCollapsed);
    }
  };

  const handleHeaderClick = (e) => {
    if (typeof onHeaderClick === 'function') {
      onHeaderClick(e);
    }

    if (collapsible) {
      toggleCollapse(e);
    }
  };

  const footerContent = pagination ? (
    <>
      {footer}
      <Pagination //
        className="listing-page-pagination"
        currentPage={pagination.currentPage}
        totalPages={pagination.totalPages}
        onPageChange={pagination.goToPage}
        itemsPerPage={pagination.itemsPerPage}
        totalItems={pagination.totalItems}
        showInfo={true}
      />
    </>
  ) : (
    footer
  );

  if (hideIfEmpty && hasNoValidChildren) {
    return null;
  }

  return (
    <div className={cleanClass(`comp-page-section ${variant && `comp-page-section-${variant}`} ${className} ${collapsible ? 'collapsible' : ''} ${isScrolled ? 'scrolled' : ''}`)} data-collapsed={isCollapsed} style={style} ref={ref}>
      {lines && <DashboardLines />}
      {title && (
        <div className={'header'} onClick={handleHeaderClick}>
          <div className={'header-left'}>
            {icon && <IconV2 icon={icon} className={'header-icon light-medium'} />}
            <div className={'header-content'}>
              {prefix && <div className={'prefix'}>{prefix}</div>}
              <h3 className={'header-title'}>
                {title}
                {tag && <p className={'tag'}>{tag}</p>}
                {info && <IconV2 icon={FiInfo} size={12} className={'light-medium'} title={info} />}
              </h3>
              {description && <p className={'header-description'}>{description}</p>}
            </div>
          </div>
          <div className={'header-right'}>
            {actions?.length > 0 && (
              <div className={'header-actions'}>
                {actions.map((action, index) => (
                  <Button key={index} {...action} />
                ))}
              </div>
            )}
            {!actions?.length && titleContent && <div className="header-title-content">{titleContent}</div>}
            {collapsible && <Button icon={FiChevronDown} className="collapse-btn ghost" size="sm" onClick={toggleCollapse} title={isCollapsed ? 'Expand' : 'Collapse'} />}
          </div>
        </div>
      )}
      {!title && !description && header && <div className={'header'}>{header}</div>}
      {!isCollapsed && (
        <div ref={contentRef} className={'content'} onScroll={handleScroll}>
          {children}
        </div>
      )}
      {footerContent && <div className={'footer'}>{footerContent}</div>}
    </div>
  );
});

PageSection.displayName = 'PageSection';

export default PageSection;
